var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretUpDown = function SvgCaretUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".caret-up-down_svg__cls-1{fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "caret-up-down_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 .879 5.061 5.061a1.5 1.5 0 1 1-2.121 2.121l-2.939-2.939-2.939 2.939A1.5 1.5 0 1 1 4.941 5.94L10 .879ZM4.939 11.939a1.5 1.5 0 0 1 2.121 0l2.939 2.939 2.939-2.939a1.5 1.5 0 1 1 2.121 2.121l-5.061 5.061-5.061-5.061a1.5 1.5 0 0 1 0-2.121Z",
    className: "caret-up-down_svg__cls-1"
  }))));
};
export default SvgCaretUpDown;